'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var icons = {
  success: 'check-circle',
  warning: 'exclamation-circle',
  danger: 'times-circle',
  error: 'times-circle',
  info: 'info-circle'
};

var Alert = function (_React$PureComponent) {
  (0, _inherits3.default)(Alert, _React$PureComponent);

  function Alert() {
    (0, _classCallCheck3.default)(this, Alert);
    return (0, _possibleConstructorReturn3.default)(this, (Alert.__proto__ || (0, _getPrototypeOf2.default)(Alert)).apply(this, arguments));
  }

  (0, _createClass3.default)(Alert, [{
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          className = _props.className,
          style = _props.style,
          type = _props.type,
          noClose = _props.noClose,
          inverse = _props.inverse,
          onClose = _props.onClose,
          children = _props.children,
          rest = (0, _objectWithoutProperties3.default)(_props, ['className', 'style', 'type', 'noClose', 'inverse', 'onClose', 'children']);

      var classes = (0, _classnames2.default)((_classNames = {
        alert: true
      }, (0, _defineProperty3.default)(_classNames, 'alert-' + type, type), (0, _defineProperty3.default)(_classNames, 'alert-' + type + '--inverse', type && inverse), (0, _defineProperty3.default)(_classNames, 'alert-dismissable', !noClose), _classNames), className);

      return React.createElement(
        'div',
        (0, _extends3.default)({}, rest, { className: classes, style: style, role: 'alert', tabIndex: 0 }),
        React.createElement('span', { className: 'icon-' + icons[type] }),
        children,
        noClose ? undefined : React.createElement(
          'button',
          { type: 'button', className: 'close', onClick: onClose },
          '\xD7'
        )
      );
    }
  }]);
  return Alert;
}(React.PureComponent);

Alert.displayName = 'AUIAlert';
Alert.defaultProps = {
  type: 'info',
  noClose: false,
  inverse: false
};
exports.default = Alert;